import { useState, useEffect } from "react";
import { useTranslation } from "../../i18n";
import CTASection from "../../components/cta-section";
import { PricingSection } from "../../components/pricing-section";

export default function Home() {
  const { t } = useTranslation();
  const [activeFeature, setActiveFeature] = useState(0);
  const [activeCustomInterface, setActiveCustomInterface] = useState(0);

  // Auto-rotate custom interfaces
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCustomInterface((prev) => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const customInterfaces = [
    {
      id: 0,
      title: t('routes.pricing.customInterfaces.0.title'),
      description: t('routes.pricing.customInterfaces.0.description'),
      image:
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Custom%20Interface-VdQTMD2mmK8e8j11MVdpVn4utXW5Bi.png",
      color: "#8B5CF6",
      features: [
        t('routes.pricing.customInterfaces.0.features.0'),
        t('routes.pricing.customInterfaces.0.features.1'),
        t('routes.pricing.customInterfaces.0.features.2'),
        t('routes.pricing.customInterfaces.0.features.3'),
      ],
    },
    {
      id: 1,
      description: t('routes.pricing.customInterfaces.1.description'),
      title: t('routes.pricing.customInterfaces.1.title'),
      image:
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Custom%20Interface%202-3octcIwUfIj2l47osDY6X3qvBMhhMq.png",
      color: "#10B981",
      features: [
        t('routes.pricing.customInterfaces.1.features.0'),
        t('routes.pricing.customInterfaces.1.features.1'),
        t('routes.pricing.customInterfaces.1.features.2'),
        t('routes.pricing.customInterfaces.1.features.3'),
      ],
    },
    {
      id: 2,
      title: t('routes.pricing.customInterfaces.2.title'),
      description: t('routes.pricing.customInterfaces.2.description'),
      image:
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Custom%20Interface%203-inuhKh57Qv5SnKeoArHU925FtD6rbF.png",
      color: "#EF4444",
      features: [
        t('routes.pricing.customInterfaces.2.features.0'),
        t('routes.pricing.customInterfaces.2.features.1'),
        t('routes.pricing.customInterfaces.2.features.2'),
        t('routes.pricing.customInterfaces.2.features.3'),
      ],
    },
  ];

  const features = [
    {
      id: 0,
      title: t('routes.pricing.features.0.title'),
      description: t('routes.pricing.features.0.description'),
      benefits: [
        t('routes.pricing.features.0.benefits.0'),
        t('routes.pricing.features.0.benefits.1'),
        t('routes.pricing.features.0.benefits.2'),
        t('routes.pricing.features.0.benefits.3'),
      ],
    },
    {
      id: 1,
      title: t('routes.pricing.features.1.title'),
      description: t('routes.pricing.features.1.description'),
      benefits: [
        t('routes.pricing.features.1.benefits.0'),
        t('routes.pricing.features.1.benefits.1'),
        t('routes.pricing.features.1.benefits.2'),
        t('routes.pricing.features.1.benefits.3'),
      ],
    },
    {
      id: 2,
      title: t('routes.pricing.features.2.title'),
      description: t('routes.pricing.features.2.description'),
      benefits: [
        t('routes.pricing.features.2.benefits.0'),
        t('routes.pricing.features.2.benefits.1'),
        t('routes.pricing.features.2.benefits.2'),
        t('routes.pricing.features.2.benefits.3'),
      ],
    },
    {
      id: 3,
      title: t('routes.pricing.features.3.title'),
      description: t('routes.pricing.features.3.description'),
      benefits: [
        t('routes.pricing.features.3.benefits.0'),
        t('routes.pricing.features.3.benefits.1'),
        t('routes.pricing.features.3.benefits.2'),
        t('routes.pricing.features.3.benefits.3'),
      ],
    },
    {
      id: 4,
      title: t('routes.pricing.features.4.title'),
      description: t('routes.pricing.features.4.description'),
      benefits: [
        t('routes.pricing.features.4.benefits.0'),
        t('routes.pricing.features.4.benefits.1'),
        t('routes.pricing.features.4.benefits.2'),
        t('routes.pricing.features.4.benefits.3'),
      ],
    },
    {
      id: 5,
      title: t('routes.pricing.features.5.title'),
      description: t('routes.pricing.features.5.description'),
      benefits: [
        t('routes.pricing.features.5.benefits.0'),
        t('routes.pricing.features.5.benefits.1'),
        t('routes.pricing.features.5.benefits.2'),
        t('routes.pricing.features.5.benefits.3'),
      ],
    },
    {
      id: 6,
      title: t('routes.pricing.features.6.title'),
      description: t('routes.pricing.features.6.description'),
      benefits: [
        t('routes.pricing.features.6.benefits.0'),
        t('routes.pricing.features.6.benefits.1'),
        t('routes.pricing.features.6.benefits.2'),
        t('routes.pricing.features.6.benefits.3'),
      ],
    },
  ];

  return (
    <div className="min-h-screen overflow-x-hidden relative">
      {/* Top Gradient Background */}

      {/* Main Content */}
      <main className="relative z-10 px-4 md:px-8 pt-32 pb-24">
        {/* Hero section removed */}

        {/* App Description Section */}
        {/* <div className="mt-32 max-w-7xl mx-auto">
          <AppDescription />
        </div> */}

        {/* App Features Showcase - Comprehensive Platform */}
        {/* <div className="mt-32 max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900"></h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto"></p>
          </div>

          <AppFeaturesShowcase />
        </div> */}

        {/* Live Demo Section */}

        {/* Pricing Section */}
        <PricingSection />
      </main>

      {/* CTA Section */}
      <div id="contact">
        <CTASection />
      </div>
    </div>
  );
}
